<template>
  <component
    :is="show_link_tag ? 'a' : non_link_tag"
    @click="$emit('click', $event)"
    v-bind="link_data">
    <slot></slot>
  </component>
</template>

<script>
export default {
  name: "IsLink",
  props: {
    is_link: {
      type: Boolean,
      default: false
    },
    non_link_tag: {
      type: String,
      default: 'span'
    },
    href: {
      type: String,
      default: ''
    }
  },
  computed: {
    show_link_tag() {
      return this.is_link && this.href
    },
    link_data() {
      if (!this.show_link_tag) return null
      return {
        href: this.href
      }
    }
  }
}
</script>
